var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.937715 8.04754L0.226013 7.35387C-0.0753378 7.06015 -0.0753378 6.5852 0.226013 6.29461L6.455 0.220288C6.75635 -0.0734289 7.24365 -0.0734289 7.54179 0.220288L13.774 6.29461C14.0753 6.58833 14.0753 7.06327 13.774 7.35387L13.0623 8.04754C12.7577 8.34438 12.2608 8.33813 11.9627 8.03504L8.28234 4.26984L8.28234 13.2501C8.28234 13.6657 7.93932 14 7.51294 14H6.48706C6.06068 14 5.71766 13.6657 5.71766 13.2501L5.71766 4.26984L2.03733 8.03504C1.73918 8.34126 1.24227 8.34751 0.937715 8.04754Z",
    fill: "#27AE60"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowUp);
export default __webpack_public_path__ + "static/media/ic-arrow-up.8eeb48a9d71308ba8ded2b81b744c04b.svg";
export { ForwardRef as ReactComponent };